import { TimeAggregationPeriod } from '../types';

// TODO: this function is here because it would cause a circular import in ./format.ts or in lib/date.ts
// I think removing barrel exports and cleaning up explore/ imports from core/ would fix this

export const getTimeAggregationPeriodLabel = (precision: TimeAggregationPeriod) => {
  switch (precision) {
    case 'hour':
      return 'Hour';
    case 'day':
      return 'Day';
    case 'week':
      return 'Week';
    case 'day_of_week':
      return 'Day of Week';
    case 'month':
      return 'Month';
    case 'quarter':
      return 'Quarter';
    case 'year':
      return 'Year';
    default:
      return precision;
  }
};
